<template>
  <div class="thai-date-picker">
    <b-form-select v-model="day" :options="dayOptions" class="thai-date-select thai-date-day" />
    <b-form-select v-model="month" :options="monthOptions" class="thai-date-select thai-date-month" />
    <b-form-select v-model="beYear" :options="yearOptions" class="thai-date-select thai-date-year" />
  </div>
</template>

<script>
import { BFormSelect } from 'bootstrap-vue'

const THAI_MONTHS = [
  'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
  'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม',
]

const BE_OFFSET = 543

function isLeapYear(ceYear) {
  return (ceYear % 4 === 0 && ceYear % 100 !== 0) || ceYear % 400 === 0
}

function daysInMonth(ceYear, monthIndex) {
  const lengths = [31, isLeapYear(ceYear) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
  return lengths[monthIndex]
}

function pad(n) {
  return String(n).padStart(2, '0')
}

export default {
  name: 'ThaiDatePicker',
  components: {
    BFormSelect,
  },
  props: {
    value: {
      type: String,
      default: null,
    },
    min: {
      type: String,
      default: null,
    },
    max: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      day: null,
      month: null,
      beYear: null,
    }
  },
  computed: {
    dayOptions() {
      const max = (this.month !== null && this.beYear !== null)
        ? daysInMonth(this.beYear - BE_OFFSET, this.month)
        : 31
      const options = [{ value: null, text: 'Day' }]
      for (let d = 1; d <= max; d++) options.push({ value: d, text: d })
      return options
    },
    monthOptions() {
      return [
        { value: null, text: 'Month' },
        ...THAI_MONTHS.map((name, index) => ({ value: index, text: name })),
      ]
    },
    yearOptions() {
      const nowBeYear = new Date().getFullYear() + BE_OFFSET
      const minBeYear = this.min ? Number(this.min.slice(0, 4)) + BE_OFFSET : nowBeYear - 100
      const maxBeYear = this.max ? Number(this.max.slice(0, 4)) + BE_OFFSET : nowBeYear + 5

      const options = [{ value: null, text: 'Year (พ.ศ.)' }]
      for (let y = maxBeYear; y >= minBeYear; y--) options.push({ value: y, text: y })
      return options
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(isoDate) {
        if (!isoDate) {
          this.day = null
          this.month = null
          this.beYear = null
          return
        }

        const [y, m, d] = isoDate.split('-').map(Number)
        this.day = d
        this.month = m - 1
        this.beYear = y + BE_OFFSET
      },
    },
    day() {
      this.emitDate()
    },
    month() {
      this.clampDay()
      this.emitDate()
    },
    beYear() {
      this.clampDay()
      this.emitDate()
    },
  },
  methods: {
    clampDay() {
      if (this.day === null || this.month === null || this.beYear === null) return
      const max = daysInMonth(this.beYear - BE_OFFSET, this.month)
      if (this.day > max) this.day = max
    },
    emitDate() {
      if (this.day === null || this.month === null || this.beYear === null) {
        this.$emit('input', null)
        return
      }

      const ceYear = this.beYear - BE_OFFSET
      const isoDate = `${ceYear}-${pad(this.month + 1)}-${pad(this.day)}`

      if (isoDate === this.value) return
      this.$emit('input', isoDate)
    },
  },
}
</script>

<style scoped>
.thai-date-picker {
  display: flex;
  gap: 8px;
}
.thai-date-select {
  min-width: 0;
}
.thai-date-day {
  flex: 0 0 25%;
}
.thai-date-month {
  flex: 1 1 auto;
}
.thai-date-year {
  flex: 0 0 35%;
}
</style>
